/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Text_To_Audio_Find_ReplaceInputs */

const en_dialog_text_to_audio_find_replace = /** @type {(inputs: Dialog_Text_To_Audio_Find_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find and replace`)
};

const es_dialog_text_to_audio_find_replace = /** @type {(inputs: Dialog_Text_To_Audio_Find_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar y reemplazar`)
};

/**
* | output |
* | --- |
* | "Find and replace" |
*
* @param {Dialog_Text_To_Audio_Find_ReplaceInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_text_to_audio_find_replace = /** @type {((inputs?: Dialog_Text_To_Audio_Find_ReplaceInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Text_To_Audio_Find_ReplaceInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_text_to_audio_find_replace(inputs)
	return en_dialog_text_to_audio_find_replace(inputs)
});